<label class="switch">
    <input type="checkbox" [checked]="isChecked" (change)="toggle()" [disabled]="isDisabled">
    <span class="slider"></span>
</label>